import React, { FC } from 'react';
import classnames from 'classnames';
import { useIntl } from 'react-intl';

import { usePlayingState } from '@/scenarios/legacy-player/hooks/usePlayingState';
import { PlayingState } from '@/scenarios/legacy-player/types/instance';

import { BaseControlProps } from '../../../types/controls';

import { getButtonAriaLabel } from './helpers/get-button-aria-label';
import styles from './styles.module.css';

interface Props extends BaseControlProps {
    onClick: () => void;
    className?: string;
}

export const PlayToggle: FC<Props> = ({ className, onClick }) => {
    const intl = useIntl();

    const { playingState } = usePlayingState();

    if (!playingState) {
        return null;
    }

    const isPlaying = [PlayingState.play, PlayingState.buffering].includes(playingState);
    const isPause = [PlayingState.pause, PlayingState.end].includes(playingState);

    return (
        <button
            aria-label={getButtonAriaLabel(intl, isPlaying, isPause)}
            onClick={onClick}
            className={classnames(styles.root, className, {
                [styles.play]: isPause,
                [styles.pause]: isPlaying,
            })}
        />
    );
};
